// Shown on the FAQs page and the homepage, and published as FAQPage structured data.
export const FAQ_ITEMS = [
    {
        question: "What is Accruewise?",
        answer:
            "Accruewise is a money app for India. You can save toward goals, track every spend automatically, pay bills and recharges, send money to bank accounts and UPI IDs, spend with a prepaid RuPay card and earn rewards, all in one app, in English or Hindi.",
    },
    {
        question: "Is Accruewise available on iPhone?",
        answer:
            "Accruewise is live on Android through Google Play. The iPhone app is coming to the App Store; join the waitlist on this site and we'll message you on launch day.",
    },
    {
        question: "How does automatic spend tracking work?",
        answer:
            "On Android, if you allow SMS access, the app looks for the transaction alerts your bank, UPI app and card send you. Only messages from bank sender IDs that mention an amount are sent to be sorted, never messages from personal numbers. Autopay and bill reminders, failed transactions and duplicate alerts are skipped, and you can edit or delete any entry.",
    },
    {
        question: "Can I track spends on iPhone?",
        answer:
            "Yes. iPhone doesn't let apps read SMS, so copy a bank alert and tap Paste bank SMS on the Add transaction screen: the amount, payee, category and date fill in for you. You can also add entries by hand.",
    },
    {
        question: "Which bills and recharges can I pay?",
        answer:
            "Mobile and DTH recharges, and bills from billers on Bharat BillPay (BBPS) such as electricity, broadband, gas and water. You pay from your Accruewise Wallet and can turn on reminders before a bill is due.",
    },
    {
        question: "How do I add money to Accruewise?",
        answer:
            "Your Accruewise Wallet, issued by our partner ToPay, has its own account details and UPI ID, so you can move money in from your bank or any UPI app. Round-ups and auto-save rules can then move money into your goals as you spend.",
    },
    {
        question: "Can I send money back to my bank?",
        answer:
            "Yes. Send money from your Accruewise Wallet to any bank account by IMPS, or pay a UPI ID. Every transfer to a bank account is confirmed with an OTP sent to your mobile.",
    },
    {
        question: "What is the Accruewise card?",
        answer:
            "A prepaid RuPay card linked to your Accruewise Wallet, for online and in-store payments. You get a virtual card in the app, can block it, reset its PIN or choose where it works in a tap, and can request a physical card.",
    },
    {
        question: "What is NCMC top-up?",
        answer:
            "If you have a National Common Mobility Card for the metro or buses, you can add money to it from your Accruewise Wallet before you reach the gate.",
    },
    {
        question: "Is my money safe with Accruewise?",
        answer:
            "Your Accruewise Wallet is issued by our partner ToPay, and payments run over encrypted connections. The app is locked by your 6-digit MPIN or fingerprint, every payment asks for it again, and transfers to a bank account are confirmed with an OTP.",
    },
    {
        question: "Can I use Accruewise in Hindi?",
        answer: "Yes. The whole app is available in English and Hindi, and you can switch any time from your profile. The Assistant understands both.",
    },
    {
        question: "Does Accruewise share my personal data?",
        answer:
            "Accruewise does not share your personal or financial data with third parties without your consent, except where required by law or described in the privacy policy.",
    },
    {
        question: "How do I delete my account?",
        answer:
            "In the app, go to Profile → About → Delete account and confirm with your MPIN or fingerprint. We settle your wallet and card and then delete the account. You can also write to care@accruewise.in.",
    },
    {
        question: "Is Accruewise available in India only?",
        answer: "Yes. Accruewise is currently available in India only.",
    },
];
